import { supabase } from '../services/supabaseClient';

export async function getAtendimentosAtivos() {
  const { data, error } = await supabase
    .from('atendimentos')
    .select('id, nome_cliente, telefone, mensalista')
    .eq('status', 'ativo');

  if (error) throw error;
  return data;
}
